import { Box } from 'reflexbox/styled-components';
import styled, { css } from 'styled-components';

const styleButtonBaseProps = new Set([
  'shape',
  'shadowHard',
  'shadowSoft',
  'double',
  'hide',
  'borderRadius',
  'buttonShadow',
  'active',
  'addLink',
  'fillColor',
  'small',
  'disabledTextColor',
]);

const styleButtonSpinnerWrapProps = new Set([
  'isAddPageModal',
  'copyLook',
  'isFeaturesDisableButton',
  'spinning',
  'disabledBackgroundColor',
  'confirmationOk',
  'backgroundColor',
  'backgroundColorHover',
]);

const styleButtonGreenProps = new Set(['linkButtonUpload']);

const ButtonBase = styled.button`
  background: #007aff;
  border: 2px solid #007aff;
  border-radius: 8px;
  outline: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 36px;
  color: #fff;
  transition: all 0.2s;

  ${(props) =>
    props.danger &&
    css`
      border-color: #ff6161;
      background: #ff6161;
      color: white;
    `}

  &:hover {
    // background: #007AFF;

    ${(props) =>
      props.danger &&
      css`
        // background: #fe231b;
        // background: #007aff;

        filter: saturate(1.5);
      `}
  }

  &[disabled] {
    background: var(--main-gray);
    border-color: var(--border-color);
    color: var(--text-tertiary);
    cursor: default;

    ${({ disabledBackgroundColor }) =>
      disabledBackgroundColor &&
      css`
        background-color: ${disabledBackgroundColor};
      `}

    ${({ disabledTextColor }) =>
      disabledTextColor &&
      css`
        color: ${disabledTextColor};
      `}
        
    

    &:hover {
      background: var(--main-gray);
      border-color: var(--border-color);
      color: var(--text-tertiary);
      cursor: default;
    }
  }

  @media (max-width: 767px) {
    width: 100%;
    line-height: 1.4em;
  }
`;

export const ButtonUnderlined = styled(ButtonBase)`
  color: var(--main-black);
  text-decoration: underline;

  background: transparent;
  border: none;
  font-size: 18px;

  &:hover {
    background: transparent;
    border: none;
  }

  ${(props) =>
    props.isLoading &&
    css`
      cursor: default;
      pointer-events: none;
    `}

  ${(props) =>
    props.isDuplicate &&
    css`
      margin-left: 30px;
      display: inline-flex;
      align-items: center;
    `}
`;

export const Button = styled(ButtonBase).withConfig({
  shouldForwardProp: (prop) => !styleButtonBaseProps.has(prop),
})`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  position: relative;
  padding: 0 24px;
  min-height: 42px;
  pointer-events: auto;

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

  ${(props) =>
    props.isAudience &&
    css`
      @media (max-width: 480px) {
        width: 100%;
        min-height: 42px;
        max-height: 42px;
      }
    `}

  @media (max-width: 767px) {
    line-height: 1.4em;
    padding: 0;

    ${(props) =>
      props.width &&
      css`
        width: 35%;
      `}
  }

  @media (max-width: 480px) {
    ${(props) =>
      props.isProducts &&
      css`
        padding: 0px 24px;
      `}
  }

  ${(props) =>
    props.breakLine &&
    css`
      width: 100%;
      word-wrap: break-word;
      text-align: center;
    `}

  ${(props) =>
    props.cancel &&
    css`
      padding: 0 20px;
      font-size: 14px;
      font-weight: normal;
      background: var(--main-background);
      border-color: var(--main-black);
      color: var(--main-black);

      &:hover {
        background: var(--hover-background);
      }
    `}

  ${(props) =>
    props.preview &&
    css`
      display: none;

      @media (max-width: 576px) {
        position: fixed;
        bottom: 80px;
        left: 50%;
        transform: translateX(-50%);
        padding: 8px;
        font-weight: bold;
        gap: 8px;
      }
    `}

  ${(props) =>
    props.newContactGroupWidth &&
    css`
      width: 180px;
      @media (max-width: 480px) {
        width: 100%;
      }
    `}

  ${(props) =>
    props.addToGroup &&
    css`
      padding: 0 20px;
      font-size: 14px;
      line-height: 26px;
      min-height: 30px;
      font-weight: bold;
      background: var(--main-gray);
      border-color: var(--border-color);
      color: var(--main-black);
      max-height: 30px;

      &:hover {
        background: var(--main-black);
        border-color: var(--border-color);
        color: var(--main-background);
      }
    `}

  ${(props) =>
    props.remove &&
    css`
      padding: 0 20px;
      font-size: 14px;
      line-height: 26px;
      min-height: 30px;
      font-weight: bold;
      background: var(--main-black);
      border-color: var(--main-black);
      color: var(--main-background);
      max-height: 30px;

      &:hover {
        background: var(--main-gray);
        border-color: var(--main-black);
        color: var(--main-black);
      }
    `}
  
  ${(props) =>
    props.isAuth &&
    css`
      height: 56px;
      min-height: 56px;
      font-size: 18px !important;
      justify-content: center;
    `}

  ${(props) =>
    props.isFullWidth &&
    css`
      width: 100% !important;
    `}

  ${(props) =>
    props.galleryButton &&
    css`
      max-height: 115px;
      overflow: hidden;
      line-height: 1.4;
    `}
  
  ${(props) =>
    props.small &&
    css`
      min-height: 32px;
      padding: 0 16px;
      line-height: 32px;
    `}

    ${(props) =>
    props.confirmationOk &&
    css`
      min-height: 32px;
      padding: 0 16px;
      line-height: 32px;
      width: 30%;
    `}

    ${(props) =>
    props.confirmationAgain &&
    css`
      color: #0155fa;
      background: var(--main-background);
      border: 2px solid #0155fa;
      min-height: 32px;
      padding: 0 16px;
      line-height: 32px;
      width: 30%;
    `}
  
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}
  
  ${(props) =>
    props.lineHeight &&
    css`
      line-height: ${props.lineHeight};
    `}
  
  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight};
    `}
  
  ${(props) =>
    props.color &&
    css`
      background: ${props.color};
      border-color: ${props.color};

      &:hover {
        background: ${props.color};
        border-color: ${props.color};
      }
    `}

  ${(props) =>
    props.color === '#ffffff' &&
    props.postButton &&
    css`
      border-color: ${props.textColor};

      &:hover {
        border-color: ${props.textColor};
      }
    `}
  
  ${(props) =>
    props.borderRadius &&
    css`
      border-radius: ${props.borderRadius};
    `}

  ${(props) =>
    props.borderColor &&
    css`
      border-color: ${props.borderColor};

      &:hover {
        border-color: ${props.borderColor};
      }
    `}

  ${(props) =>
    props.hoverColor &&
    css`
      &:hover {
        background: ${props.hoverColor};
      }
    `}
  
  ${(props) =>
    props.width &&
    css`
      width: ${props.width} !important;
    `}

  ${(props) =>
    props.widthMobile &&
    css`
      @media (max-width: 768px) {
        width: ${props.widthMobile} !important;
      }
    `}
  

  ${(props) =>
    props.removeLink &&
    css`
      background: #fe231b;
      color: #fff;
      border-color: #fe231b;
      text-transform: none;

      &:hover {
        background: #fe231b;
      }
    `}

  ${(props) =>
    props.flexCenter &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}

    ${(props) =>
    props.billingHistory &&
    css`
      margin-left: 0;
      padding: 0 0 0 12px;
      position: relative;
      line-height: 14px;
      background: transparent;
      color: #0155fa;
      font-weight: bold;
      text-align: center;
      border: none;
      text-decoration: underline;
      font-size: 12px;

      @media (max-width: 767px) {
        line-height: 2.4em;
      }
    `}

  ${(props) =>
    props.addLink &&
    css`
      position: relative;
      width: 100%;
      padding: 15px;
      min-height: 0;
      line-height: 22px;
      background: transparent;
      color: #0155fa;
      font-weight: bold;
      text-align: center;
      border: 2px dashed rgba(1, 85, 250, 0.3);

      &:hover {
        background: transparent;
        border-color: #0155fa;
      }

      @media (max-width: 767px) {
        line-height: 2.4em;
        width: auto;
        padding: 0 10px;
      }
    `}

  ${(props) =>
    props.$actionButton &&
    css`
      padding: 0;
      height: 38px;
      width: 140px;
      font-size: 12px;
    `}

  ${(props) =>
    props.pageButton &&
    css`
      padding: 0;
      height: 38px;
      font-size: 12px;
    `}

  ${(props) =>
    props.linkBoxMobile &&
    css`
      max-width: 65px;
      min-height: 35px;
      border-color: var(--border-color);
      background: var(--main-background);
      color: var(--secondary-gray);
      border-radius: 3px;

      &:hover {
        background: var(--hover-background);
        border-color: var(--border-color);
      }
    `}

  ${(props) =>
    props.loginShopify &&
    css`
      padding: 0;
      min-width: 265px;
      border-color: var(--border-color);
      background: var(--main-background);
      //color: #808182;
      //border-radius: 3px;

      &:hover {
        background: var(--hover-background);
        border-color: var(--border-color);
      }
    `}

  ${(props) =>
    props.addAccountStep &&
    css`
      padding-left: 80px;
      color: #fff;
      width: 300px;
      display: flex;
      align-items: center;
      border-radius: 12px;
      text-align: center;

      @media (max-width: 767px) {
        line-height: initial;
        padding: 0;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
    `}

  ${(props) =>
    props.extract &&
    css`
      display: flex;
      align-items: center;
      color: #fff;
      border-radius: 5px;
      min-height: 42px;
      text-transform: uppercase;
      font-size: 13px;
      background: #1b97f5;
      border-color: #1b97f5;

      &:hover {
        background: #1b97f5;
        border-color: #1b97f5;
      }
    `}

  ${(props) =>
    props.linkButtonIcon &&
    css`
      padding: 0 28px;
      font-size: 14px;
      line-height: 30px;
      min-height: 38px;
      font-weight: bold;
      background: var(--main-gray);
      border-color: var(--border-color);
      color: var(--main-black);

      &:hover {
        background: var(--hover-background);
        border-color: var(--border-color);
      }
    `}

  ${(props) =>
    props.transparentBlackBorder &&
    css`
      font-weight: bold;
      color: var(--main-black);
      background: transparent;
      border-color: var(--main-black);

      &:hover {
        background: var(--hover-background);
        border-color: var(--main-black);
      }
    `}

  ${(props) =>
    props.useTikTok &&
    css`
      border: 1px solid var(--border-color);
      height: 54px;
    `}

  ${(props) =>
    props.blue &&
    css`
      color: #ffffff;
      //font-weight: bold;
      background: #3673fc;
      border-color: #3673fc;

      &:hover {
        background: #497ff9;
        border-color: #497ff9;
      }
    `}
  
  ${(props) =>
    props.fontWeight &&
    css`
      font-weight: ${props.fontWeight};
    `}

  ${(props) =>
    props.stipe &&
    css`
      padding: 0 36.44px;
      color: #ffffff;
      background: #635bff;
      border-color: #7a74f7;

      &:hover {
        background: #635bff;
        border-color: #7a74f7;
      }
    `}

  ${(props) =>
    props.whatsApp &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 34px;
      font-size: 12px;
      font-weight: bold;
      color: #ffffff;
      background: #55cd6c;
      border-color: #55cd6c;

      &:hover {
        background: #77c786;
        border-color: #77c786;
      }
    `}

  ${(props) =>
    props.zapier &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 34px;
      color: #ffffff;
      background: #ff4a00;
      border-color: #ff4a00;
      /*
      &:hover {
        background: #ff6424;
        border-color: #ff6424;
      }*/
    `}

  ${(props) =>
    props.affiliateFeedbackSuccess &&
    css`
      position: absolute;
      bottom: 30px;
    `}

  ${(props) =>
    props.affiliateFeedbackButton &&
    css`
      display: none;
      font-size: 13px;
      min-height: 32px;
      line-height: 26px;

      @media (max-width: 568px) {
        display: block;
        padding: 10px;
        margin: 0 0 10px 0 !important;
      }
    `}

    ${(props) =>
    props.shape &&
    css`
      max-height: 42px;
      width: 48%;
      padding: 0;
      font-weight: bold;
      border-color: var(--border-color);
      background: var(--main-background);
      color: var(--main-black);

      &:hover {
        background-color: var(--subtle-background);
        border-color: var(--border-color);
      }

      @media (max-width: 768px) {
        width: 48%;
      }
    `}
  
  ${(props) =>
    props.buttonShadow &&
    css`
      width: 102px;

      @media (max-width: 768px) {
        width: 20%;
      }

      @media (max-width: 576px) {
        width: 102px;
      }
    `}
  ${(props) =>
    props.double &&
    css`
      box-shadow:
        rgb(255, 255, 255) 4px 4px 0px 0px,
        rgb(224, 226, 233) 4px 4px 0px 2px;
    `}

  ${(props) =>
    props.postShadow &&
    css`
      width: 75px;
      height: 25px;

      @media (max-width: 768px) {
        width: 75px;
        height: 25px;
      }

      &:first-child {
        margin-right: 20px;
      }
    `}

  ${(props) =>
    props.shadowSoft &&
    css`
      box-shadow: 0 4px 4px 0 rgb(0 0 0 / 16%);
    `}

  ${(props) =>
    props.shadowHard &&
    css`
      box-shadow: 4px 4px 0 0 #282f37;
    `}
  
  ${(props) =>
    props.active &&
    css`
      cursor: default;
      border: 3px #17ce17 solid !important;

      &:hover {
        background: transparent;
        border: 3px #17ce17 solid !important;
      }
    `}

  ${(props) =>
    props.social &&
    css`
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      box-shadow: rgb(0 0 0 / 7%) 0 10px 30px 0;

      @media (max-width: 767px) {
        padding: 0 20px;
      }
    `}

  ${(props) =>
    props.previewCopyLink &&
    css`
      margin-top: -8px;
      position: relative;
      top: 4px;
      padding: 0 10px;
      min-height: 24px;
      font-size: 12px;
      font-weight: bold;
      background-color: var(--subtle-background);
      border-color: var(--border-color);

      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background: var(--hover-background);
        border-color: var(--border-color);
      }

      @media (max-width: 767px) {
        padding: 0 20px;
      }
    `}

  ${(props) =>
    props.botsCopy &&
    css`
      font-weight: 400;
      margin-right: 15px;
      background: var(--main-gray);
    `}

  ${(props) =>
    props.blueButton &&
    css`
      color: #fff;
      background: rgb(0, 133, 255);
      border-color: rgb(0, 133, 255);

      &:hover {
        background: rgba(0, 133, 255, 0.7);
        border-color: rgb(0, 133, 255);
      }

      @media (max-width: 767px) {
        background: rgb(0, 133, 255);
      }
    `}

  ${(props) =>
    props.productBtn &&
    css`
      color: #fff;
      font-weight: bold;
      background: #3ab777;
      border-color: #3ab777;

      &:hover {
        background: rgba(58, 183, 119, 0.7);
        border-color: rgb(58, 183, 119);
      }

      @media (max-width: 767px) {
        background: rgb(58, 183, 119);
      }
    `}

  ${(props) =>
    props.productBtnDisabled &&
    css`
      color: #fff;
      font-weight: bold;
      background: #9e9e9e;
      border-color: #9e9e9e;
      cursor: default;

      &:hover {
        background: #9e9e9e;
        border-color: #9e9e9e;
      }

      @media (max-width: 767px) {
        background: #9e9e9e;
      }
    `}


  ${(props) =>
    props.blackButton &&
    css`
      margin-left: 5px;
      color: #fff;
      background: #000;
      border-color: var(--main-black);
      font-size: 10px;

      &:hover {
        background: #000;
        border-color: var(--main-black);
      }

      @media (max-width: 767px) {
        background: #000;
      }
    `}

  ${(props) =>
    props.insideModalPreviewCopy &&
    css`
      @media (max-width: 767px) {
        position: absolute;
        right: 0;
        top: 7px;
        background: transparent;
        width: 40px;
        padding: 0;
        border: none;
      }
    `}

  ${(props) =>
    props.insideModalPreviewCustomize &&
    css`
      @media (max-width: 767px) {
        width: 135px;
        font-size: 14px;
        padding: 10px;
        min-height: 45px;
        background: #009940;
        border: none;
        margin-left: 20px;
      }
    `}

  ${(props) =>
    props.removeSmall &&
    css`
      padding: 0 16px;
      min-height: 32px;
      max-height: 32px;
      font-size: 13px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 30px;
    `}

  ${(props) =>
    props.removeProfilePicture &&
    css`
      @media (max-width: 568px) {
        width: 100px;
        flex: none;
        margin-left: 20px;
      }
    `}
  


  ${(props) =>
    props.addInstagram &&
    css`
      padding: 0 24px 0 40px !important;
      color: #fff;
      border: none;
      background: #f09433;
      background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
      border-radius: 12px;
      text-align: center;
      gap: 24px;

      &:hover {
        border: none;
        color: #fff;
        background: #f09433;
        background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
        border-color: transparent;
        text-align: center;
      }

      @media (max-width: 767px) {
        border: none;
        border-color: transparent;
        color: #fff;
        background: #f09433;
        background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
        text-align: center;
      }
    `}

  ${(props) =>
    props.addInstagramShop &&
    css`
      margin-top: 15px;
      border-radius: 12px;
      font-size: 17px;
      text-align: center;
      padding: 0 !important;
      justify-content: center;

      @media (max-width: 767px) {
        margin-top: 15px;
        border-radius: 12px;
        font-size: 17px;
        text-align: center;
        padding: 0 !important;
        justify-content: center;
      }
    `}


  ${(props) =>
    props.addFacebook &&
    css`
      padding: 0 24px 0 40px !important;
      border: none;
      color: #fff;
      background: #4167b2;
      border-radius: 12px;

      &:hover {
        border: none;
        color: #fff;
        background: #4167b2;
      }

      @media (max-width: 767px) {
        border: none;
        color: #fff;
        background: #4167b2;
      }
    `}

  ${(props) =>
    props.addTikTok &&
    css`
      border: none;
      color: #fff;
      background: #000;
      border-radius: 12px;

      &:hover {
        border: none;
        color: #fff;
        background: #000;
      }

      @media (max-width: 767px) {
        border: none;
        color: #fff;
        background: #000;
      }
    `}

  ${(props) =>
    props.continue &&
    css`
      justify-content: center;
      padding: 0;
    `}

  ${(props) =>
    props.limeButton &&
    css`
      background-color: rgb(116, 204, 42) !important;
      border-color: rgb(116, 204, 42) !important;
      color: #fff !important;

      &:hover,
      &:focus {
        background-color: rgb(116, 204, 42) !important;
        border-color: rgb(116, 204, 42) !important;
        color: #fff !important;
      }
    `}

  ${(props) =>
    props.migrateButton &&
    css`
      max-height: 40px;
      height: 40px;
      min-height: 40px;
      width: 37%;
      text-align: center;
      padding: 0;
      flex: none;
      margin: 0;
      display: block;
      font-size: 14px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      @media (max-width: 767px) {
        width: 37%;
      }

      @media (max-width: 568px) {
        width: 37%;
      }
    `}


  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}

  ${(props) =>
    props.contactModal &&
    css`
      &:hover {
        background: rgb(255, 97, 97);
        border-color: rgb(255, 97, 97);
      }
    `}

  ${(props) =>
    props.isManagePages &&
    css`
      @media (max-width: 576px) {
        border-radius: 8px;
        font-size: 12px;
        color: var(--main-black);
        font-weight: bold;
        background: var(--hover-background);
        border: 1px solid var(--border-color);
        padding: 4px 16px;
        min-height: 30px;
        width: unset;
        margin-left: auto;
      }
    `}
  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
      border: none;
    `}

          &:hover {
    ${({ backgroundColorHover }) =>
      backgroundColorHover &&
      css`
        background-color: ${backgroundColorHover};
      `}
  }
`;

export const ButtonConfirm = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
`;

export const FlexWrap = styled.div`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  @media (max-width: 767px) {
    display: flex;
    width: 78%;
    flex-direction: row;
    justify-content: space-between;
  }
`;
export const MobButtonWrap = styled.div`
  @media (max-width: 767px) {
    width: 48%;
    padding: 0;
    margin: 0;
  }
`;

const LongButtonMix = css`
  display: block;
  width: 100%;
  min-height: 40px;
`;

export const ButtonLong = styled(ButtonBase)`
  ${LongButtonMix};

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  ${(props) =>
    props.buttonOpenFormEmail &&
    css`
      width: 100%;
      display: flex;
      align-items: center;
      border: none;
      background: none;
      max-height: 50px;
    `}
  ${(props) =>
    props.zapier &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 34px;
      color: #ffffff;
      background: #ff4a00;
      border-color: #ff4a00;
      font-size: 12px;
      font-weight: bold;

      &:hover {
        background: #ff6424;
        border-color: #ff6424;
      }
    `}
  ${(props) =>
    props.sendPulse &&
    css`
      background: #00a0c1;
      border-color: #00a0c1;
    `}
  ${(props) =>
    props.active &&
    css`
      background: #f7f5ec;
      border: 1px solid var(--border-color);
      color: var(--main-black);

      &:hover {
        opacity: 0.8;
      }
    `}

  ${(props) =>
    props.whatsApp &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
      padding: 0 34px;
      color: #ffffff;
      background: #69ce6d;
      border-color: #69ce6d;

      &:hover {
        background: #69ce6d;
        border-color: #69ce6d;
        opacity: 0.8;
      }
    `}
  

  ${(props) =>
    props.flexCenter &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  
  
  ${(props) =>
    props.integrations &&
    css`
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: bold;
    `}
    ${(props) =>
    props.buttonConnectSettings &&
    css`
      height: 40px;
      width: 90%;
      border-radius: 30px;
      margin: 0 10px 20px 10px;
      text-align: center;
      display: block;
      background: var(--main-background);
      color: var(--main-black);
      border: 1px solid var(--border-color);
      text-transform: lowercase;
      font-weight: bold;
      font-size: 14px;

      &:hover {
        background: var(--hover-background);
        border: 1px solid var(--border-color);
      }
      ::first-letter {
        text-transform: uppercase;
      }
      ${(props) =>
        props.disconnect &&
        css`{
          background-color: var(--main-black);
          color: #ffffff;
          border-color: var(--main-black);
          margin:0;
                
          &:hover{
          background-color: #2c2c2c;
          color: #eaeaea;
          border: none;
          }
     `}
    `}
        
  ${(props) =>
    props.buttonBanner &&
    css`{
          height: 100%;
          border-radius: 30px 30px 0 0;
          border-color: white;
          background-color: var(--main-background);
          border:0;
        }
   `}   
   ${(props) =>
    props.buttonAddAccount &&
    css`{
          width: 80%;
          background-color: var(--main-background);
          border: 1px solid var(--border-color);
          color: var(--secondary-gray);
          align-self: center;
          margin-top: 20px;
        }
   `}
  
  
  
  ${(props) =>
    props.isGoogleSheet &&
    css`
      background: var(--main-background);
      border: 1px solid var(--border-color);

      &:hover {
        background: #f7f5ec;
        border: 1px solid var(--border-color);
      }
    `}
  
  ${(props) =>
    props.slack &&
    css`
      justify-content: center;
      padding-right: 41px;
      color: #fff;
      background: #4a154b;
      border: 2px solid #4a154b;

      &:hover {
        background: #490e4a;
        border: 2px solid #490e4a;
      }
    `}

  ${(props) =>
    props.discord &&
    css`
      justify-content: center;
      padding-right: 41px;
      color: #fff;
      background: #5865f2;
      border: 2px solid #5865f2;

      &:hover {
        background: #490e4a;
        border: 2px solid #490e4a;
      }
    `}


  ${(props) =>
    props.telegram &&
    css`
      justify-content: center;
      padding-right: 41px;
      color: #fff;
      background: #139bd0;
      
      border: 2px solid #139bd0;
      {/*  &:hover {
        background: #1e94cc;
        border: 2px solid #1e94cc;
      } */}
     
    `}
  
  ${(props) =>
    props.shopify &&
    css`
      font-size: 16px;
      color: var(--main-black);
      background: transparent;
      border: 1px solid #000;
      border-radius: 6px;

      &:hover {
        background-color: var(--surface-elevated);
      }
    `}
  ${(props) =>
    props.isTelegram &&
    css`
      color: var(--main-black);
      background: var(--main-background);
      border: 1px solid var(--border-color);

      &:hover {
        background: #f7f5ec;
        border: 1px solid var(--border-color);
      }
    `}
  ${(props) =>
    props.isShopify &&
    css`
      color: var(--main-black);
      background: #e2ffab;
      border: 1px solid var(--border-color);

      &:hover {
        background: #f7f5ec;
        border: 1px solid var(--border-color);
      }
    `}
  ${(props) =>
    props.$actionButton &&
    css`
      background: #489be0;
      color: #fff;
      border: 1px solid #489be0;

      &:hover {
        background: #489be0;
      }
    `}
  
  
  ${(props) =>
    props.googleSheet &&
    css`
      position: relative;
      padding-left: 50px;
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      color: #fff;
      background: #4285f4;
      border: none;
      border-radius: 3px;
      min-height: 39.5px;

      &:hover {
        background: #3367d6;
        border: none;
        border-radius: 3px;
      }
    `}
  
  ${(props) =>
    props.isGoogleSheet &&
    css`
      background: var(--main-background);
      color: rgba(0, 0, 0, 0.54);
      box-shadow:
        0 1px 2px rgba(0, 0, 0, 0.25),
        0 2.5px 2.5px rgba(0, 0, 0, 0.22);

      &:hover {
        background: var(--main-background);
      }
    `}

  ${(props) =>
    props.tagButton &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      background: #f2f6f9;
      color: #1bc3fe;
      text-transform: uppercase;
      border-color: #f2f6f9;
      border-radius: 0;

      &:hover {
        border-radius: 0;
        background: #e0e6ea;
        border-color: #f2f6f9;
      }
    `}

  ${(props) =>
    props.editAction &&
    css`
      height: 54px;
      border-width: 2px;
      border-style: solid;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      cursor: default;
      text-overflow: ellipsis;
      letter-spacing: 0.56px;
      border-radius: 16px;
      padding: 0 24px;
      color: #fff;
    `}

  ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor};
      border-color: ${props.bgColor};

      &:hover {
        background: ${props.bgColor};
        border-color: ${props.bgColor};
      }
    `}
  ${(props) =>
    props.textColor &&
    css`
      color: ${props.textColor};
    `}

  ${(props) =>
    props.saveHeaderSettings &&
    css`
      @media (max-width: 767px) {
        min-width: 60px;
        min-height: 60px;
        width: 60px;
        height: 60px;
        color: transparent;
        border-radius: 50%;
      }
    `}

  ${(props) =>
    props.addTagModal &&
    css`
      cursor: pointer;
      width: 48% !important;
    `}

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}

  ${(props) =>
    props.cursor &&
    css`
      cursor: ${props.cursor};
    `}

  ${(props) =>
    props.isTitle &&
    css`
      width: 55%;
      margin: 0 auto;
    `}

  ${(props) =>
    props.flexCenter &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}

  ${(props) =>
    props.integrationButton &&
    css`
      color: #fff;
      font-size: 16px;
      font-weight: 400;
      border: 2px solid transparent;
    `}

  ${(props) =>
    props.CTAButton &&
    css`
      font-size: 12px;
      margin-right: 18px;
      height: 44px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 0 15px;
    `}
`;

export const ButtonSubscribe = styled(ButtonBase)`
  ${LongButtonMix};
  margin-top: auto;
  position: relative;
  background: #007aff;
  font-weight: bold;
  border: none;

  &:hover {
    background: rgba(0, 122, 255, 0.8);
  }

  ${(props) =>
    props.subscribeEditBlock &&
    css`
      background: #007aff;
      border-color: #007aff;
      color: #fff;
    `}
`;

const ButtonOutlinedMix = css`
  background: var(--main-background);
  border-color: var(--main-black);
  color: var(--main-black);

  &:hover {
    background: #e8e8e8;
  }
`;

export const ButtonOutlined = styled(Button)`
  ${ButtonOutlinedMix};
  margin-right: 15px;

  ${(props) =>
    props.copyLink &&
    css`
      border: none;
      color: #0155fa;

      &:hover {
        background: transparent;
      }
    `}

  ${(props) =>
    props.isAddPageModal &&
    css`
      text-align: left;
    `}
`;

export const ButtonLongOutlined = styled(ButtonLong)`
  ${ButtonOutlinedMix};
`;

const ButtonSpinnerMix = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonSpinnerWrap = styled(Button).withConfig({
  shouldForwardProp: (prop) => !styleButtonSpinnerWrapProps.has(prop),
})`
  ${ButtonSpinnerMix};

  ${(props) =>
    props.isAddPageModal &&
    css`
      height: 48px;
      width: 104px;
    `}

  ${(props) =>
    props.copyLook &&
    css`
      width: 100%;
      font-size: 12px;
      height: 28px;
      min-height: 28px;
      min-width: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
    `}
  ${(props) =>
    props.isFeaturesDisableButton &&
    css`
      pointer-events: none;
      opacity: 0.3;
      background: #9e9e9e;
      border-color: #9e9e9e;
    `}

  ${(props) =>
    props.spinning &&
    css`
      pointer-events: none;
      cursor: default;
    `}

  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}

 ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}

 ${({ fontSize }) =>
    fontSize &&
    css`
      font-size: ${fontSize};
    `}

${({ fontWeight }) =>
    fontWeight &&
    css`
      font-weight: ${fontWeight};
    `}
`;

export const ButtonOutlinedSpinnerWrap = styled(ButtonOutlined)`
  ${ButtonSpinnerMix};
`;

export const ButtonLargeSpinnerWrap = styled(ButtonLong)`
  ${ButtonSpinnerMix};

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.login &&
    css`
      background: rgb(137 60 99);
      border: none;
      color: #fff;

      &:hover {
        background: rgba(161, 95, 131, 0.8);
      }
    `}


  ${(props) =>
    props.saveSettings &&
    css`
      width: 150px;
      margin-left: auto;
    `}


  ${(props) =>
    props.saveSection &&
    css`
      background: rgb(93, 190, 132);
      border-color: rgb(93, 190, 132);
      color: #fff;

      &:hover {
        background: rgba(93, 190, 132, 0.8);
      }
    `}

  ${(props) =>
    props.saveSectionDesign &&
    css`
      height: 80px;
      font-size: 18px;
      border-radius: 3px;
    `}

  ${(props) =>
    props.insideHeaderMenu &&
    css`
      margin-top: 35px !important;
      color: #fff !important;
      background: #007aff !important;
    `}
`;

export const SpinnerBox = styled(Box)`
  margin-left: 8px;

  ${(props) =>
    props.flexNone &&
    css`
      flex: none;
    `}
`;

export const ButtonTransparent = styled.button`
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;

  &:hover,
  &:focus,
  &:active {
    background: transparent;
    border: none;
    outline: none;
    box-shadow: none;
  }

  ${(props) =>
    props.deleteTag &&
    css`
      position: absolute;
      bottom: 22px;
      right: 5px;
      margin-left: auto;
    `}
`;

export const ButtonCloseIcon = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: none;
  background-color: rgb(234 234 234);
  cursor: pointer;
  z-index: 10;

  &::before,
  &::after {
    content: '';
    display: block;
    width: 10px;
    height: 1px;
    background-color: rgb(28 28 28);
    position: absolute;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;

export const IconContainer = styled.div`
  position: relative;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ButtonGreen = styled(Button).withConfig({
  shouldForwardProp: (prop) => !styleButtonGreenProps.has(prop),
})`
  padding: 0 18px;
  font-size: 13px;
  line-height: 30px;
  min-height: 32px;
  font-weight: bold;
  color: #fff;
  background: #17ce17;
  border: none;

  &:hover,
  &:focus {
    background: rgba(23, 206, 23, 0.8);
    border: none;
  }

  @media (max-width: 767px) {
    line-height: 30px;
    padding: 0 18px;
  }

  ${(props) =>
    props.bgColor &&
    css`
      background: ${props.bgColor};
      margin-bottom: 0;
      &:hover,
      &:focus {
        background: ${props.bgColor};
        opacity: 0.8;
      }
    `}
  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}
  ${(props) =>
    props.isTemplates &&
    css`
      @media (max-width: 480px) {
        padding: 0 16px;
        max-width: unset;
      }
    `}
  ${(props) =>
    props.buyPro &&
    css`
      position: relative;
      left: -10px;
    `}
  ${(props) =>
    props.$newStyle &&
    css`
      background-image: linear-gradient(135deg, rgb(255, 92, 55), rgb(255, 29, 177));
      border: none;
      left: unset;
      &:hover,
      &:focus {
        background-image: linear-gradient(135deg, rgb(255, 92, 55), rgb(255, 29, 177));
        opacity: 0.8;
      }
    `}


  ${(props) =>
    props.isTemplates &&
    css`
      @media (max-width: 480px) {
        padding: 0 16px;
        max-width: unset;
      }
    `}
  ${(props) =>
    props.buyPro &&
    css`
      position: relative;
      left: -10px;
    `}
  
  ${(props) =>
    props.$isRelative &&
    css`
      position: relative;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  


  ${(props) =>
    props.mobileHeader &&
    css`
      display: none;
      text-transform: uppercase;
      padding: 3px 18px;
      max-width: 170px;

      @media (max-width: 767px) {
        display: block;
      }
    `}
  
  ${(props) =>
    props.linkButtonUpload &&
    css`
      cursor: pointer;
      padding: 0 28px;
      font-size: 14px;
      min-height: 38px;
    `}

  ${(props) =>
    props.maxWidth &&
    css`
      @media (max-width: 568px) {
        max-width: ${props.maxWidth} !important;
      }
    `}
  
  ${(props) =>
    props.maxWidthDesktop &&
    css`
      max-width: ${props.maxWidthDesktop} !important;
    `}

  

  ${(props) =>
    props.upload &&
    css`
      position: relative;
      max-height: 32px;
      margin-left: 30px;

      @media (max-width: 568px) {
        margin-left: 50px;
      }
    `}

  ${(props) =>
    props.upgradeAccount &&
    css`
      width: 100%;
      min-height: 55px;
      font-size: 16px;
      border-radius: 0;
      border-bottom-left-radius: 26px;
      border-bottom-right-radius: 26px;
    `}

  ${(props) =>
    props.disabledButton &&
    css`
      color: #fff;
      font-weight: bold;
      background: #9e9e9e;
      border-color: #9e9e9e;
      cursor: default;
      pointer-events: none;

      &:hover,
      &:focus {
        background: #9e9e9e;
        border-color: #9e9e9e;
      }

      @media (max-width: 767px) {
        background: #9e9e9e;
      }
    `}

  ${(props) =>
    props.botsButton &&
    css`
      max-height: 24px;
      height: 24px;
      min-height: 24px;
      line-height: 1.2;
      font-size: 12px;
    `}

  ${(props) =>
    props.$flex &&
    css`
      display: flex;
      justify-content: center;
      align-content: center;
    `}

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight};
    `}

  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}
  ${(props) =>
    props.sectionHeaderCover &&
    css`
      min-width: 145px;
    `}

  ${(props) =>
    props.disabledStyles &&
    css`
      background: var(--main-gray);
      border-color: var(--border-color);
      color: var(--text-tertiary);
      cursor: pointer;

      &:hover {
        background: var(--main-gray);
        border-color: var(--border-color);
        color: var(--text-tertiary);
        cursor: pointer;
      }
    `}
`;

export const ButtonNewEmail = styled(Button)`
  @media (max-width: 576px) {
    width: 100% !important;
  }
`;
